import { useEffect } from 'react';
import { enableAnalytics } from '../utils/analytics';

export function AnalyticsManager() {
  useEffect(() => {
    // Always enable analytics (no consent required)
    enableAnalytics();
  }, []);

  return null;
}
